import fetchApi from '@/lib/tools/api'
import {Producer, UserProducer} from '@/types'
import {Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from '@mui/material'
import React, {useCallback, useEffect, useState} from 'react'
import {useDataProvider, useNotify, useRecordContext, useRefresh} from 'react-admin'

interface LinkProducerResponse {
    success: boolean
    message: string
    user: any
}

export default function LinkProducerDialog() {

    const [open, setOpen] = useState(false)
    const [value, setValue] = useState<Producer | null>(null)
    const record = useRecordContext<UserProducer>()
    const dataProvider = useDataProvider()
    const refresh = useRefresh()
    const notify = useNotify()

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    const handleSave = async () => {
        if (value) {
            try {
                const response = await fetchApi<LinkProducerResponse>(
                    `/producers/users/${record.id}/link-producer`,
                    {producerId: value.id},
                    null,
                    'POST'
                )

                if (response.success) {
                    refresh()
                    notify(response.message || 'Entreprise ajoutée', {type: 'success'})
                    handleClose()
                } else {
                    notify(response.message || 'Erreur lors de la liaison', {type: 'error'})
                }
            } catch (error) {
                notify('Erreur lors de la liaison de l\'entreprise', {type: 'error'})
                console.error(error)
            }
        } else {
            handleClose()
        }
    }

    const [producers, setProducers] = useState<Producer[]>([])
    const [inputValue, setInputValue] = useState('')

    const updateOptions = useCallback((inputValue: string) => {
        dataProvider.getList('producers', {
            filter: {
                q: inputValue
            },
            sort: {field: 'id', order: 'DESC'},
            pagination: {page: 1, perPage: 25}
        })
            .then(({data}) => {
                setProducers(data)
            })
    }, [inputValue])

    useEffect(() => {
        updateOptions(inputValue)
    }, [inputValue])

    useEffect(() => {
        updateOptions('')
    }, [])

    return (
        <div>
            <Button onClick={handleOpen} variant="contained">
                Lier une entreprise
            </Button>

            <Dialog fullWidth open={open} onClose={handleClose}>
                <DialogTitle>Lier une entreprise à l'utilisateur {record.firstName} {record.lastName}</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        options={producers}
                        noOptionsText={'Aucun résultat'}
                        getOptionLabel={(option) => `${option.name} -- ${option.name_enterprise}`}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        autoComplete
                        includeInputInList
                        filterSelectedOptions
                        filterOptions={(options) => options.filter(option => {
                            return !record.producers.includes(option.id)
                        })}
                        onChange={(event, newValue) => {
                            setValue(newValue)
                        }}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue)
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Sélectionnez une entreprise" fullWidth/>
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave} color="primary">Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
};
